"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Vue } from "vue-property-decorator";
let ElPhoneVerifyCodeInput = class extends Vue {
  constructor() {
    super(...arguments);
    this.time = 0;
    this.buttonLock = false;
  }
  mounted() {
    if (this.lock_name) {
      let lock = localStorage.getItem(this.lock_name);
      if (lock) {
        let _lock = Number(lock);
        this.lock(_lock);
      }
    }
  }
  sendPhoneCode() {
    this.$emit("sendCode", this.lock);
  }
  elInput(value) {
    this.$emit("input", value);
  }
  clearLock() {
    this.time = 0;
  }
  lock(time) {
    this.time = time;
    this.buttonLock = true;
    let countdown = () => {
      this.time--;
      if (this.lock_name) {
        let _time = this.time.toString();
        localStorage.setItem(this.lock_name, _time);
      }
      if (this.time <= 0) {
        this.buttonLock = false;
        localStorage.removeItem(this.lock_name);
        clearInterval(countdownInterval);
      }
    };
    countdown.call(null);
    const countdownInterval = setInterval(countdown, 1e3);
  }
};
__decorateClass([
  PropSync("value", {
    type: String,
    default: function() {
      return "";
    }
  })
], ElPhoneVerifyCodeInput.prototype, "input_value", 2);
__decorateClass([
  PropSync("lockName", {})
], ElPhoneVerifyCodeInput.prototype, "lock_name", 2);
__decorateClass([
  PropSync("lockText", {})
], ElPhoneVerifyCodeInput.prototype, "lock_text", 2);
ElPhoneVerifyCodeInput = __decorateClass([
  Component({})
], ElPhoneVerifyCodeInput);
export {
  ElPhoneVerifyCodeInput as default
};
